import { mountActiveLayers } from './active-layers.js';
import {setKiteSpotsEnabled} from '../layers/kite-spots.js';
// Pannello livelli v2 — ricostruito moderno ma con la STESSA struttura logica
// della v1 (categorie, default, persistenza apertura gruppi). I gruppi layer
// si aggiungono via registerGroup() man mano che i milestone li portano.
import { setBase } from '../mapcore.js';
import {
    setParametro, setOption, setNetworks, setHideZeroRain, isRainAccumParam, setFilters,
} from '../layers/stations.js';
import { setRadarEnabled } from '../layers/radar.js';
import { initUnipa } from '../layers/unipa.js';
import { setHailEnabled } from '../layers/hail.js';
import { setSatelliteEnabled, setSatelliteOptions } from '../layers/satellite.js';
import { setEnabled as setLightningEnabled } from '../layers/lightning.js';
import { mountWSNowStatus } from './wsnow-status.js';
import { OBSERVATION_AREAS } from '../lib/observation-areas.js';
import { setStormsEnabled } from '../layers/storms.js';
import { setAircraftEnabled } from '../layers/aircraft.js';
import { setShipsEnabled } from '../layers/ships.js';
import { setSondehubEnabled } from '../layers/sondehub.js';
import { setIrsSoundingEnabled } from '../layers/irs-sounding.js';
import { OVERLAY_DEFS, setOverlayEnabled } from '../layers/overlays.js';
import { buildToolsGroup } from './tools.js';
import { setDerivedEnabled, setPollenSpecies, setAirPollutant, setQuakesDays } from '../layers/derived-points.js';
import { setAnalysisEnabled, setTempVariationHours, setTempVariationMarkersVisible } from '../layers/analysis-points.js';
import { setRiskEnabled, setAlertsDay } from '../layers/risk-layers.js';
import { setInterpolEnabled, setInterpolParametro, setInterpolOpacity } from '../layers/interpol.js';
import { setProvinceMask } from '../layers/province-mask.js';
import { setTimelineVisible, isTimelineVisible } from './timeline-stack.js';
import { setMarineExtraEnabled } from '../layers/marine-extra.js';
import { setSpaghettiEnabled, setInsetsEnabled } from '../layers/misc.js';
import { setDrpcExtraEnabled } from '../layers/drpc-extra.js';
import { setWaveAnimEnabled } from '../layers/wave-anim.js';
import { initGeoportaleControls } from '../layers/geoportale-sicilia.js';
import { SICILY_BOUNDS } from '../lib/config.js';
import { chartUnitForParam } from '../lib/params.js';
import {
    setWslamEnabled, setWslamProduct, setWslamStep, getWslamSteps, setWslamOpacity,
    getWslamStepIndex, getWslamProducts, getWslamState,
} from '../layers/wslam.js';

export const PARAM_OPTIONS = [
    ['temperatura', '🌡️ Temp. Attuale'], ['tmax', '☀️ Temp. Max'], ['tmin', '❄️ Temp. Min'],
    ['rain', '🌧️ Pioggia Giornaliera'], ['rain1h', '🌧️ Pioggia cumulata…'], ['rainrate', '🌧️ Intensità (mm/h)'],
    ['rainmonth', '🗓️ Pioggia Mensile'], ['rainyear', '📅 Pioggia Annuale'],
    ['vento', '🌬️ Vento attuale'], ['raffica', '💨 Raffica'], ['umidita', '💧 Umidità'],
    ['comfort', '◉ Comfort termico'],
    ['dewPoint', '💧 Dew Point'], ['apparent', '🌡️ Temp. Percepita'], ['humidex', '🥵 Humidex'],
    ['wetbulb', '💦 Bulbo Umido'], ['dewspread', '🌫️ Spread T-Dp'],
    ['windchill', '🧊 Wind Chill'], ['pressione', '🧭 Pressione'], ['neve', '❄️ Livello Neve (cm)'],
    // Rimossi da "Dato stazioni" (Giuseppe 2026-07-03): idrometrico + parametri
    // mare (temp/onda/periodo/corrente/livello) — dati diversi, non da rendere
    // come marker stazione. Restano nella scheda stazione e nei layer dedicati.
];

const NETWORKS = [
    ['sias', 'Rete SIAS'], ['drpc', 'DRPC Sicilia'], ['proag', 'Protezione Civile Agrigento'], ['ws', 'Rete Weather Sicily'],
    ['meteosicilia', 'Rete MeteoSicilia'], ['cms', 'Centro Meteorologico Siciliano'],
    ['meteomessina', 'MeteoMessina.it'],
    ['meteolicata', 'Rete MeteoLicata.it'],
    ['cisar_ag', 'CISAR Agrigento'],
    ['inaf', 'INAF'],
    ['cnr', 'CNR'],
    ['bess', 'BESS – INGV'],
    ['rainwatch', 'Rainwatch – Rete Pluviometrica del Longano'],
    ['meteocaltanissetta', 'MeteoCaltanissetta'],
    ['metar', 'METAR'], ['mareografica', 'ISPRA mareografico'],
];

const VALUE_FILTER_RANGES = {
    temperatura: { min: -20, max: 50, step: 1 },
    tmax: { min: -20, max: 55, step: 1 },
    tmin: { min: -25, max: 45, step: 1 },
    dewPoint: { min: -25, max: 35, step: 1 },
    apparent: { min: -25, max: 60, step: 1 },
    humidex: { min: 0, max: 60, step: 1 },
    wetbulb: { min: -10, max: 35, step: 1 },
    dewspread: { min: 0, max: 35, step: 1 },
    windchill: { min: -30, max: 35, step: 1 },
    umidita: { min: 0, max: 100, step: 1 },
    rain: { min: 0, max: 300, step: 1 },
    rain1h: { min: 0, max: 300, step: 1 },
    rain3h: { min: 0, max: 300, step: 1 },
    rain6h: { min: 0, max: 300, step: 1 },
    rain12h: { min: 0, max: 300, step: 1 },
    ...Object.fromEntries([24,48,72,96,120].map(h => [`rain${h}h`, { min: 0, max: 1000, step: 1 }])),
    rainrate: { min: 0, max: 200, step: 1 },
    rainmonth: { min: 0, max: 300, step: 5 },
    rainyear: { min: 0, max: 2000, step: 25 },
    vento: { min: 0, max: 160, step: 1 },
    raffica: { min: 0, max: 200, step: 1 },
    pressione: { min: 850, max: 1100, step: 1 },
    neve: { min: 0, max: 300, step: 1 },
};

function valueFilterRange(parametro) {
    const base = VALUE_FILTER_RANGES[parametro] || { min: -50, max: 100, step: 1 };
    const unit = chartUnitForParam(parametro);
    return { ...base, label: unit ? `Valore (${unit})` : 'Valore' };
}

function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
}

function toggleRow(id, label, checked, onChange) {
    const row = el(`
        <label class="wsv2-toggle">
            <span>${label}</span>
            <input type="checkbox" id="${id}" ${checked ? 'checked' : ''}>
            <i class="wsv2-switch" aria-hidden="true"></i>
        </label>`);
    row.querySelector('input').addEventListener('change', (e) => onChange(e.target.checked));
    return row;
}

// Gruppi come DIV normali, NON <details>: Chrome recente renderizza i details
// con content-visibility interna e sul canvas WebGL il pannello si TRONCAVA
// esattamente al confine di un gruppo (bug Giuseppe, round 10). Zero magie.
function group(title, key, open) {
    let openState = open;
    try {
        const saved = JSON.parse(localStorage.getItem('wsv2-groups') || '{}');
        if (key in saved) openState = !!saved[key];
    } catch (e) {}
    const g = el(`
        <div class="wsv2-group ${openState ? 'is-open' : ''}" data-group="${key}">
            <button type="button" class="wsv2-group__head">${title}</button>
            <div class="wsv2-group__body"${openState ? '' : ' hidden'}></div>
        </div>`);
    // compat con il codice esistente che usa g.open (deep-link, test, help)
    Object.defineProperty(g, 'open', {
        get() { return g.classList.contains('is-open'); },
        set(v) {
            g.classList.toggle('is-open', !!v);
            g.querySelector('.wsv2-group__body').hidden = !v;
        },
    });
    g.querySelector('.wsv2-group__head').addEventListener('click', () => {
        g.open = !g.open;
        try {
            const saved = JSON.parse(localStorage.getItem('wsv2-groups') || '{}');
            saved[key] = g.open;
            localStorage.setItem('wsv2-groups', JSON.stringify(saved));
        } catch (e) {}
    });
    return g;
}

export function buildPanel(map, urlState) {
    initUnipa(map);
    const body = document.getElementById('layersBody');
    if (!body) return;

    // --- Dato stazioni (select parametro) --------------------------------------
    // 2026-07-03: SPOSTATO dal drawer al popover "Visualizzazione" (pattern
    // niente-duplicati). L'id resta #selectParametro: persist, deep-link,
    // toolbar, legend, tools e main.js lo cercano per id.
    const sel = el(`<select class="wsv2-select" id="selectParametro" aria-label="Parametro da visualizzare">
        ${PARAM_OPTIONS.map(([v, l]) => `<option value="${v}">${l}</option>`).join('')}
    </select>`);
    const rainWindowOption = sel.querySelector('option[value="rain1h"]');
    const rainWindow = el(`<select class="wsv2-select wsv2-rain-window" id="selectRainWindow"
        aria-label="Periodo delle piogge cumulate" hidden>
        <option value="rain1h">Ultima ora</option><option value="rain3h">Ultime 3 ore</option>
        <option value="rain6h">Ultime 6 ore</option><option value="rain12h">Ultime 12 ore</option>
        <option value="rain24h">Ultime 24 ore</option><option value="rain48h">Ultime 48 ore</option>
        <option value="rain72h">Ultime 72 ore</option><option value="rain96h">Ultime 96 ore</option>
        <option value="rain120h">Ultime 120 ore</option>
    </select>`);
    const chooseRainWindow = (value) => {
        if (!/^rain(?:1|3|6|12|24|48|72|96|120)h$/.test(value)) return;
        rainWindow.value = value;
        rainWindowOption.value = value;
        sel.value = value;
        rainWindow.hidden = false;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
    };
    sel.addEventListener('change', () => {
        rainWindow.hidden = !/^rain(?:1|3|6|12|24|48|72|96|120)h$/.test(sel.value);
        setParametro(sel.value);
    });
    rainWindow.addEventListener('change', () => chooseRainWindow(rainWindow.value));
    document.addEventListener('wsv2:rain-window-select', (e) => chooseRainWindow(e.detail?.value));
    const activeBox = el('<div class="wsv2-active-box wsv2-active-box--layers" hidden>📊 <b>0</b> stazioni attive<small></small></div>');
    document.addEventListener('wsv2:stations', (e) => {
        // Semantica v1 (updateActiveStationsBox): il numero grande = stazioni
        // ONLINE (fresche <2h, boa ondametrica inclusa) A PRESCINDERE dal
        // parametro — stesso numero di live. Il dettaglio = quante misurano
        // il parametro corrente (i pallini davvero in mappa).
        const n = (e.detail.records || []).length;
        const online = Math.max(n, Number(e.detail.online) || 0);
        activeBox.hidden = false;
        activeBox.querySelector('b').textContent = String(online);
        const activeParam = e.detail.parametro || sel.value;
        const lbl = (PARAM_OPTIONS.find(([v]) => v === activeParam)?.[1]
            || (/^rain(?:1|3|6|12|24|48|72|96|120)h$/.test(activeParam) ? `Piogge ultime ${activeParam.slice(4, -1)} ore` : ''))
            .replace(/^[^A-Za-zÀ-ÿ]*/, '');
        activeBox.querySelector('small').textContent =
            n < online ? `${n} misurano ${lbl.toLowerCase()}` : `${online} online`;
    });

    // --- Visualizzazione: ICONCINA dedicata sulla mappa (stile v1
    //     btn-view-options + ws-view-options-panel), NON nel drawer dei layer.
    //     Un tap sull'occhio apre il popover compatto coi soli toggle di
    //     visualizzazione; si chiude cliccando fuori o ripremendo il bottone.
    //     Default v1: sat ON, marker ON, webcam OFF, vento OFF, quota ON,
    //     estremi ON, isole ON. Gli id restano gli stessi (persist/deep-link).
    const baseSat = document.documentElement.classList.contains('wsv2-base-sat');
    const viewWrap = el(`
        <div class="wsv2-view-options" id="wsv2-view-options">
            <button id="btn-view-options" type="button" class="wsv2-iconbtn" title="Opzioni visualizzazione"
                    aria-label="Opzioni visualizzazione" aria-expanded="false" aria-controls="ws-view-options-panel">
                <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="1.8"/>
                </svg>
            </button>
            <section id="ws-view-options-panel" class="wsv2-view-options__panel" aria-label="Opzioni visualizzazione" hidden>
                <span>Visualizzazione</span>
            </section>
        </div>`);
    const vb = viewWrap.querySelector('#ws-view-options-panel');
    // Sezione "Reti" (spostata dal drawer 2026-07-03): costruita PRIMA dei
    // toggle perché chkMarkers la mostra/nasconde reattivamente — ha senso
    // scegliere le reti solo quando le stazioni sono in mappa. Gli id net-*
    // restano gli stessi (persist). ARPACAL non compare qui: e' una sorgente
    // tecnica calabrese sempre attiva e non disattivabile dall'utente.
    const netSec = el('<div class="wsv2-view-options__nets" id="wsv2-view-networks"><div class="wsv2-view-options__sec">Reti</div></div>');
    const networkInputs = new Map();
    const selectedNetworks = () => NETWORKS
        .filter(([value]) => networkInputs.get(value)?.checked)
        .map(([value]) => value);
    let allNetworksInput = null;
    const syncAllNetworksToggle = () => {
        if (allNetworksInput) allNetworksInput.checked = selectedNetworks().length === NETWORKS.length;
    };
    const allNetworksRow = toggleRow('net-all', 'Tutte le reti', true, checked => {
        networkInputs.forEach(input => { input.checked = checked; });
        syncAllNetworksToggle();
        setNetworks(checked ? [...NETWORKS.map(([value]) => value), 'unipa'] : []);
    });
    allNetworksRow.classList.add('wsv2-network-master');
    allNetworksInput = allNetworksRow.querySelector('input');
    // È un controllo derivato dalle singole reti: la persistenza deve salvare
    // queste ultime, non rieseguire il comando globale durante il ripristino.
    allNetworksInput.dataset.persist = 'false';
    netSec.appendChild(allNetworksRow);
    NETWORKS.forEach(([value, label]) => {
        const row = toggleRow('net-' + value, label, true, () => {
            syncAllNetworksToggle();
            const selected = selectedNetworks();
            setNetworks(selected.length === NETWORKS.length ? [...selected, 'unipa'] : selected);
        });
        networkInputs.set(value, row.querySelector('input'));
        netSec.appendChild(row);
    });
    // "Dato stazioni" (selettore parametro): NON più dentro il popover
    // Visualizzazione, ma come CARD fluttuante sull'interfaccia, SUBITO SOTTO
    // l'iconcina occhio (richiesta Giuseppe 2026-07-07: il menu a tendina deve
    // stare "fuori" da Visualizzazione, sempre a portata). Appare solo con "Mostra
    // stazioni" attivo (dataSec.hidden pilotato da chkMarkers, invariato). Inserito
    // nel wrapper .wsv2-view-options PRIMA del popover → nel grid sta tra il bottone
    // e il popover. #selectParametro resta l'id (deep-link/persist/legend/tools).
    const dataSec = el(`<div class="wsv2-view-options__nets wsv2-param-dock" id="wsv2-view-data">
        <button type="button" class="wsv2-param-dock__tab" id="btn-param-dock-toggle"
                aria-label="Nascondi dato sulla mappa" aria-expanded="true" title="Nascondi dato sulla mappa">›</button>
        <div class="wsv2-view-options__sec">Dato sulla mappa <button type="button" id="btn-param-guide" class="wsv2-param-guide-btn" title="Guida ai parametri" aria-label="Guida ai parametri">?</button></div>
    </div>`);
    dataSec.appendChild(sel);
    dataSec.appendChild(rainWindow);
    viewWrap.insertBefore(dataSec, vb);
    const paramDockBtn = dataSec.querySelector('#btn-param-dock-toggle');
    const setParamDockCollapsed = (collapsed, persist = true) => {
        dataSec.classList.toggle('is-collapsed', collapsed);
        paramDockBtn.textContent = collapsed ? '‹' : '›';
        paramDockBtn.title = collapsed ? 'Mostra dato sulla mappa' : 'Nascondi dato sulla mappa';
        paramDockBtn.setAttribute('aria-label', paramDockBtn.title);
        paramDockBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (persist) {
            try { localStorage.setItem('wsv2-param-dock-collapsed', collapsed ? '1' : '0'); } catch (e) {}
        }
    };
    try { setParamDockCollapsed(localStorage.getItem('wsv2-param-dock-collapsed') === '1', false); } catch (e) {}
    paramDockBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        setParamDockCollapsed(!dataSec.classList.contains('is-collapsed'));
    });
    // Guida ai parametri (port v1 #param-info-popover): spiega gli indici meno
    // comuni così l'utente sa cosa sta guardando. Popover nativo, toggle dal "?".
    initParamGuide(dataSec.querySelector('#btn-param-guide'));
    // Toggle "Nascondi stazioni senza pioggia": compare SOLO con un parametro
    // pioggia ad accumulo attivo; di default OFF → si vedono anche gli 0.
    const hideZeroRow = toggleRow('chkHideZeroRain', '🌧️ Nascondi stazioni senza pioggia', false, v => setHideZeroRain(v));
    vb.appendChild(hideZeroRow);
    const syncHideZeroRow = () => { hideZeroRow.hidden = !isRainAccumParam(sel.value); };
    sel.addEventListener('change', syncHideZeroRow);
    syncHideZeroRow();
    const blendRow = el(`<label class="wsv2-interpol-blend" hidden>
        <span>Intensità colore <output>100%</output></span>
        <input type="range" id="ws-interpol-opacity" min="0" max="100" step="5" value="100" aria-label="Intensità del campo interpolato">
    </label>`);
    dataSec.appendChild(blendRow);
    const blendInput = blendRow.querySelector('input');
    try {
        const saved = localStorage.getItem('wsv2-interpol-opacity');
        if (saved !== null && Number.isFinite(Number(saved))) blendInput.value = String(Math.max(0, Math.min(100, Number(saved))));
    } catch {}
    const applyBlend = () => {
        blendRow.querySelector('output').textContent = blendInput.value + '%';
        setInterpolOpacity(Number(blendInput.value) / 100);
    };
    applyBlend();
    blendInput.addEventListener('input', () => {
        applyBlend();
        try { localStorage.setItem('wsv2-interpol-opacity', blendInput.value); } catch {}
    });
    const syncStationControls = () => {
        const markers = document.getElementById('chkMarkers')?.checked ?? true;
        const interpolation = document.getElementById('chkInterpol')?.checked ?? false;
        dataSec.hidden = netSec.hidden = !markers && !interpolation;
        blendRow.hidden = !interpolation;
    };
    vb.appendChild(toggleRow('chkBaseSat', 'Vista satellitare 🛰️', baseSat, v => setBase(map, v ? 'sat' : 'osm')));
    // Toggle "Timeline": mostra/nasconde il riquadro timeline (osservazioni+radar).
    // Sincronizzato con la ✕ del riquadro; persistito da persist.js come gli altri.
    const timelineRow = toggleRow('chkTimeline', '🕒 Timeline', isTimelineVisible(), v => setTimelineVisible(v));
    vb.appendChild(timelineRow);
    const chkTimeline = timelineRow.querySelector('input');
    document.addEventListener('wsv2:timeline-close-request', () => {
        if (chkTimeline && chkTimeline.checked) { chkTimeline.checked = false; chkTimeline.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    // "Mostra/nascondi stazioni" = PRIMA voce del popover (sotto l'intestazione).
    // Pilota anche la card "Dato stazioni" (dataSec, ora fuori dal popover): la
    // nasconde quando le stazioni sono off.
    const markersRow = toggleRow('chkMarkers', 'Mostra stazioni 📍', true, v => {
        setOption('visible', v);
        // reattivo: persist/deep-link dispatchano change → passa da qui
        syncStationControls();
        // BUG 2026-07-03: con le stazioni nascoste la timeline −24/+48 (che
        // mostra proprio stazioni/previsioni) deve sparire → main.js ascolta.
        document.dispatchEvent(new CustomEvent('wsv2:stations-toggle', { detail: { visible: v } }));
    });
    // Prima voce del popover, subito sotto il titolo "Visualizzazione" (<span>).
    vb.querySelector('span').after(markersRow);
    // v1 2026-07-03: webcam qui, accanto a "Mostra stazioni" (era nel gruppo extra)

    vb.appendChild(toggleRow('me-webcam', 'Mostra webcam 📷', false, v => setMarineExtraEnabled('webcam', v)));
    // Stesso ID per conservare preferenze e collegamenti esistenti.
    vb.appendChild(toggleRow('chkIdrometri', '🌊 Livello idrometrico', false, v => setDrpcExtraEnabled('idrometri', v)));
    // Gli hotspot osservati FIRMS sono una visualizzazione live, non un indice
    // di rischio: il controllo vive qui e non nel riquadro Rischi & allerte.
    vb.appendChild(toggleRow('risk-firms', '🔥 Incendi live', false, v => setRiskEnabled('firms', v)));
    // "Mostra direzione" SOSTITUISCE i marker con le bussole vento (v1 chkWind)
    vb.appendChild(toggleRow('chkWind', 'Mostra direzione vento 🧭', false, v => setOption('wind', v)));
    vb.appendChild(toggleRow('chkInstantLabels', 'Etichetta INSTANT sui marker', true, v => setOption('instantLabels', v)));
    vb.appendChild(toggleRow('chkAltitudeLabels', 'Altitudine sui marker', true, v => setOption('altitudeLabels', v)));
    const temperatureExtremesRow = toggleRow('chkTemperatureExtremes', 'Temperatura: massima/minima in atto', false, v => setOption('temperatureExtremes', v));
    temperatureExtremesRow.title = 'Cerchio rosso: temperatura alla massima giornaliera. Azzurro: alla minima. Solo temperatura attuale e rilevazioni degli ultimi 15 minuti.';
    vb.appendChild(temperatureExtremesRow);
    const temperatureExtremesHelp = el('<p hidden style="font-size:12px;padding:0 12px 8px">Rosso: massima del giorno · Azzurro: minima del giorno. Solo temperatura attuale, dati entro 15 minuti.</p>');
    temperatureExtremesRow.addEventListener('change', () => { temperatureExtremesHelp.hidden = !temperatureExtremesRow.querySelector('input').checked; });
    vb.appendChild(temperatureExtremesHelp);
    vb.appendChild(toggleRow('chkMarkerExtremes', 'Max/Min sui marker', true, v => setOption('extremes', v)));
    const islandInsetsRow = toggleRow('chkIslandInsets', 'Mostra isole 🏝️', true, v => setInsetsEnabled(v));
    islandInsetsRow.classList.add('wsv2-island-toggle');
    vb.appendChild(islandInsetsRow);
    // "Estremi live": era un bottone 🏆 a sé nella topbar — spostato qui nel
    // popover Visualizzazione (richiesta utente 2026-07-06). È un'AZIONE (apre il
    // pannello top-5), non un toggle → riga-bottone dedicata. initExtremes ascolta.
    const extremesRow = el(`<button type="button" class="wsv2-toggle wsv2-view-action" id="btnExtremesRow"><span>🏆 Estremi live</span><i aria-hidden="true">›</i></button>`);
    extremesRow.addEventListener('click', () => {
        voSetOpen(false);
        document.dispatchEvent(new CustomEvent('wsv2:open-extremes'));
    });
    markersRow.after(extremesRow);
    // Popover: toggle + "Reti" (condizionale). "Dato stazioni" è nel dock timeline.
    vb.appendChild(netSec);
    document.body.appendChild(viewWrap);
    const voBtn = viewWrap.querySelector('#btn-view-options');
    const voSetOpen = (open) => {
        vb.hidden = !open;
        voBtn.classList.toggle('is-open', open);
        voBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    voBtn.addEventListener('click', () => voSetOpen(vb.hidden));
    // Chiusura al click/tap fuori: pointerdown in CAPTURE — il canvas MapLibre
    // gestisce i click in proprio e il click semplice non sempre arriva a document.
    document.addEventListener('pointerdown', (e) => {
        if (!vb.hidden && !viewWrap.contains(e.target)) voSetOpen(false);
    }, true);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !vb.hidden) voSetOpen(false); });

    // --- Nowcast & cielo ------------------------------------------------------
    const gNow = group('🌧️ WS Now · tempo reale', 'nowcast', true);
    const nowB = gNow.querySelector('.wsv2-group__body');
    const areaPresets = el('<div class="wsv2-observation-presets" role="group" aria-label="Inquadratura della mappa" style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px;padding:4px 0;background:var(--ws-bg-solid)"></div>');
    for (const [area, label] of [['sicily', 'Sicilia'], ['italy', 'Italia'], ['europe', 'Europa']]) {
        const button = el(`<button type="button" class="wsv2-wsnow__follow" data-observation-area="${area}" style="width:auto;flex:1;margin:0">${label}</button>`);
        button.addEventListener('click', () => {
            setSatelliteOptions({ area, product: 'auto' });
            map.setMinZoom(1);
            map.fitBounds(OBSERVATION_AREAS[area].zoomBounds, {
                padding: { top: 75, bottom: 130, left: 30, right: 30 }, duration: 800,
            });
        });
        areaPresets.appendChild(button);
    }
    nowB.appendChild(areaPresets);
    mountWSNowStatus(nowB, () => {
        for (const id of ['chkRadar', 'chkLightning', 'chkTemporali']) {
            const input = document.getElementById(id);
            if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        setSatelliteOptions({ area: 'italy', product: 'auto' });
        map.setMinZoom(1);
        map.fitBounds(OBSERVATION_AREAS.italy.zoomBounds, {
            padding: { top: 75, bottom: 130, left: 30, right: 30 }, duration: 800,
        });
    });
    nowB.appendChild(el('<p class="wsv2-observation-note">Radar pioggia e fulmini.</p>'));
    const hooks = el('<div></div>');
    for (const [id, label, setter] of [['chkRadar', '🌧️ Radar pioggia', setRadarEnabled], ['chkSatellite', '☁️ Satellite nubi', setSatelliteEnabled], ['chkLightning', '⚡ Fulmini · sempre Italia', setLightningEnabled]]) {
        hooks.appendChild(toggleRow(id, label, false, setter));
    }
    nowB.appendChild(hooks);
    const rainStatus = el('<p class="wsv2-observation-note" id="radarSourceStatus" role="status">Radar pioggia</p>');
    nowB.appendChild(rainStatus);
    document.addEventListener('wsv2:radar-status', event => {
        const data = event.detail || {};
        const label = data.unit === 'mm/h' ? 'Radar · pioggia al suolo' : data.unit === 'dBZ' ? 'Radar · echi atmosferici' : 'Radar pioggia';
        const clock = Number.isFinite(data.baseTimeMs) ? new Date(data.baseTimeMs).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Rome' }) : null;
        rainStatus.textContent = data.available
            ? `${label}${clock ? ' · dato delle ' + clock : ''}${data.warning ? ' · ' + data.warning : ''}`
            : `${label} · temporaneamente non disponibile`;
    });

    const requestedArea = urlState?.raw?.get('area');
    if (OBSERVATION_AREAS[requestedArea] && requestedArea !== 'sicily') {
        setSatelliteOptions({ area: requestedArea, product: 'auto' });
        map.setMinZoom(requestedArea === 'world' ? 0 : 1);
        map.fitBounds(OBSERVATION_AREAS[requestedArea].zoomBounds, {
            padding: { top: 75, bottom: 130, left: 30, right: 30 }, duration: 0,
        });
    }
    nowB.appendChild(el('<p class="wsv2-observation-note">Radar: <a href="https://radar.protezionecivile.it/" target="_blank" rel="noopener noreferrer">mosaico nazionale DPC · CC BY-SA</a>, integrato dagli echi del <a href="https://eumetnet.github.io/openradardata-documentation/" target="_blank" rel="noopener noreferrer">radar maltese · EUMETNET OPERA · CC BY 4.0</a> dove disponibili e dal radar <a href="https://idrologia.unipa.it/it/radar" target="_blank" rel="noopener noreferrer">HYCLIC · Università di Palermo</a> quando aggiornato. Satellite mondiale: EUMETSAT, NOAA e JMA tramite NASA GIBS. Fulmini: Blitzortung.org. Copertura variabile secondo la rete.</p>'));
    nowB.appendChild(toggleRow('chkHail', '🧊 Grandine (radar)', false, v => setHailEnabled(v)));
    nowB.appendChild(toggleRow('chkTemporali', '⛈️ Tracking temporali · Italia', false, v => setStormsEnabled(v)));
    const aircraftRow = toggleRow('chkAircraft', '✈ Aerei Italia · quota e temperatura', false, v => setAircraftEnabled(v));
    nowB.appendChild(aircraftRow);
    const aircraftNote = el('<p class="wsv2-observation-note">Solo aerei sul territorio italiano, isole comprese. Quota in metri e temperatura esterna alla quota dell’aereo, ricavata dai dati di volo. Solo aerei con temperatura disponibile e recente. In 3D la quota rialza i marker. Un unico archivio conserva posizione, quota e temperatura senza scadenza automatica. La timeline mostra i campioni storici disponibili. Confine: <a href="https://www.geoboundaries.org/api/current/gbOpen/ITA/ADM0/" target="_blank" rel="noopener">ISTAT / geoBoundaries · CC BY 3.0</a>.</p>');
    const aircraftStatus = document.createElement('span');
    aircraftStatus.id = 'aircraftLiveStatus';
    aircraftStatus.setAttribute('role', 'status');
    aircraftStatus.style.display = 'block';
    aircraftNote.appendChild(aircraftStatus);
    nowB.appendChild(aircraftNote);
    if (['1','true','yes','on'].includes(String(urlState?.raw?.get('aircraft') || '').toLowerCase())) {
        const toggle = aircraftRow.querySelector('input'); toggle.checked = true;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const shipsRow=toggleRow('chkShips','🚢 Navi · meteo dal mare',false,v=>setShipsEnabled(v));
    nowB.appendChild(shipsRow);
    const shipsNote=el('<p class="wsv2-observation-note">Misure reali WMO VOS via NOAA OSMC nel Mediterraneo. Solo bollettini entro 3 ore; età sempre visibile, in ambra oltre 90 minuti. Posizione e misure sono quelle del bollettino, non AIS in diretta. Dati mancanti omessi. In 3D: sagoma illustrativa al livello del mare. Nello storico i dati attuali vengono nascosti.</p>');
    const shipsStatus=document.createElement('span');shipsStatus.id='shipsLiveStatus';shipsStatus.setAttribute('role','status');shipsStatus.style.display='block';shipsNote.appendChild(shipsStatus);nowB.appendChild(shipsNote);
    if(['1','true','yes','on'].includes(String(urlState?.raw?.get('ships')||'').toLowerCase())) {const toggle=shipsRow.querySelector('input');toggle.checked=true;toggle.dispatchEvent(new Event('change',{bubbles:true}));}
    const sondeRow = toggleRow('chkSondehub', '🎈 Radiosonda LIVE', false, v => setSondehubEnabled(v));
    nowB.appendChild(sondeRow);
    nowB.appendChild(toggleRow('chkIrsSounding', '🛰️ MTG IRS spettrale', false, v => setIrsSoundingEnabled(v)));
    if (['1', 'true', 'yes', 'on'].includes(String(urlState?.raw?.get('sonde') || '').toLowerCase())) {
        const toggle = sondeRow.querySelector('input');
        toggle.checked = true;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
    body.appendChild(gNow);

    // --- Overlay dichiarativi (WMS/WMTS/image, registro port v1) -------------
    const groupTitles = {
        nowcast2: null, // gli overlay nowcast vanno nel gruppo gNow già creato
        fields: ['📊 Campi & analisi', 'fields'],
        risks: ['⚠️ Rischi & allerte', 'risks'],
        sea: ['🌊 Mare & acque', 'sea'],
        extra: ['🗺️ Mappa & extra', 'extra'],
    };
    const groupEls = { nowcast: nowB };
    for (const [key, def] of Object.entries(OVERLAY_DEFS)) {
        let gb = groupEls[def.group];
        if (!gb) {
            const meta = groupTitles[def.group] || [def.group, def.group];
            const g = group(meta[0], meta[1], false);
            body.appendChild(g);
            gb = groupEls[def.group] = g.querySelector('.wsv2-group__body');
        }
        gb.appendChild(toggleRow('ovl-' + key, def.label, false, v => setOverlayEnabled(key, v)));
        if (key === 'soilMoisture' || key === 'droughtRaster') {
            const href = key === 'soilMoisture' ? '/cambiamenti/#soil' : '/cambiamenti/#drought';
            const source = key === 'soilMoisture' ? '/assets/data/soil-moisture-latest.json' : '/assets/data/edo-drought.json';
            const meta = el(`<p style="margin:2px 0 8px 28px;font-size:11px;line-height:1.45;color:#627781"><span>Data del dato: caricamento…</span> · <a href="${href}" style="color:inherit;text-decoration:underline">dettagli e legenda ↗</a></p>`);
            gb.appendChild(meta);
            fetch(source, {cache:'no-store'}).then(r => r.ok ? r.json() : null).then(data => {
                const date = data?.obs_date;
                meta.querySelector('span').textContent = date ? `Data del dato: ${date}` : 'Data non disponibile';
            }).catch(() => { meta.querySelector('span').textContent = 'Data non disponibile'; });
        }
    }

    // Catalogo turistico-culturale e naturalistico ufficiale della Regione.
    // Il contenuto e' dinamico: il pannello resta snello anche quando il
    // catalogo viene aggiornato dal job di sincronizzazione server-side.
    const gGeoportale = group('🏛️ Geoportale Sicilia', 'geoportale-sicilia', false);
    body.appendChild(gGeoportale);
    const kiteGroup=group('KITE E VENTO','kite',false),kiteBody=kiteGroup.querySelector('.wsv2-group__body');
    kiteBody.appendChild(toggleRow('chkKiteSpots','◇ Spot kitesurf',false,v=>setKiteSpotsEnabled(v)));
    kiteBody.appendChild(el('<p class="wsv2-observation-note"><a href="https://wslam.weathersicily.it/kite/">Apri spot, previsioni e confronto dei modelli</a></p>'));
    body.appendChild(kiteGroup);
    initGeoportaleControls(gGeoportale.querySelector('.wsv2-group__body'));

    // --- Layer derivati a punti (batch A port v1) -----------------------------
    const selRow = (id, opts, onChange) => {
        const r = el(`<select class="wsv2-select wsv2-select--sub" id="${id}">${opts.map(([v, l]) => `<option value="${v}">${l}</option>`).join('')}</select>`);
        r.addEventListener('change', () => onChange(r.value));
        return r;
    };
    const drvPlacement = {
        territory: ['risks', '🚧 Strade e lavori · CCISS'],
        rainReports: ['nowcast', '🙋🌧️ Segnalazioni pioggia (live)'],
        imergRain: ['nowcast', '🛰️🌧️ Pioggia satellite (mare)'],
        pollen: ['fields', '🌾 Pollini'],
        air: ['fields', '🌫️ Qualità aria'],
        airObs: ['fields', '🏭📍 Aria misurata'],
        aeronetDust: ['fields', '🟤 Polveri sahariane (misurate)'],
        quakes: ['risks', '🔴 Terremoti'],
        edoDrought: ['risks', '🌵 Siccità (CDI)'],
        emsActivations: ['risks', '🛰️ Emergenze mappate'],
        tideGauges: ['sea', '📏 Mareografi'],
        // (2026-07-03: argo rimosso come in v1; 2026-07-11: +imerg/aeronet/edo/ems sweep-6)
    };
    for (const [key, [grp, label]] of Object.entries(drvPlacement)) {
        const gb = groupEls[grp];
        if (!gb) continue;
        gb.appendChild(toggleRow('drv-' + key, label, false, v => setDerivedEnabled(key, v)));
        if (key === 'territory') gb.appendChild(el('<p id="territory-layer-status" role="status" style="font-size:12px;line-height:1.4"></p>'));
        if (key === 'pollen') gb.appendChild(selRow('drv-pollen-species', [['all', 'Tutte le specie'], ['grass', 'Graminacee'], ['olive', 'Olivo'], ['ragweed', 'Ambrosia'], ['mugwort', 'Artemisia'], ['birch', 'Betulla'], ['alder', 'Ontano']], setPollenSpecies));
        if (key === 'air') gb.appendChild(selRow('drv-air-pollutant', [['aqi', 'Indice AQI'], ['pm25', 'PM2.5'], ['pm10', 'PM10'], ['o3', 'Ozono'], ['no2', 'NO₂'], ['uv', 'UV'], ['dust', 'Polveri']], setAirPollutant));
        if (key === 'quakes') gb.appendChild(selRow('drv-quakes-days', [['1', 'Ultime 24h'], ['7', 'Ultimi 7 giorni'], ['30', 'Ultimi 30 giorni']], v => setQuakesDays(Number(v))));
    }

    // --- Campi & analisi: ∆T + cumulate (batch D port v1) ---------------------
    {
        const gb = groupEls.fields;
        if (gb) {
            const stationValuesRow = toggleRow('ana-tv-stations', '📍 Valori delle singole stazioni', true, setTempVariationMarkersVisible);
            stationValuesRow.hidden = true;
            gb.appendChild(toggleRow('ana-tempVariation', '↕ Variazione temperatura', false, v => {
                stationValuesRow.hidden = !v;
                setAnalysisEnabled('tempVariation', v);
            }));
            gb.appendChild(selRow('ana-tv-hours', [['1', 'Ultima ora'], ['12', 'Ultime 12h'], ['24', 'Ultime 24h']], v => setTempVariationHours(Number(v))));
            gb.appendChild(stationValuesRow);
            // Gli accumuli da 1 a 120 ore sono nel selettore Dato sulla mappa.
        }
    }

    // --- Interpolazione + campi WSLam (M3 port v1) -----------------------------
    {
        const gb = groupEls.fields;
        // Interpolazione (campo colore): resta nel popover Visualizzazione (subito
        // sotto "Mostra stazioni"), NON nel menu laterale. Interpola il PARAMETRO
        // ATTIVO (sel: temp/umidità/…) sulle stazioni visibili. (Prima era ancorata
        // a dataSec.after, ma dataSec è uscito dal popover → ora dopo markersRow.)
        markersRow.after(toggleRow('chkInterpol', '🎨 Interpolazione (campo colore)', false, v => {
            setInterpolParametro(sel.value);
            setInterpolEnabled(v);
            syncStationControls();
        }));
        sel.addEventListener('change', () => setInterpolParametro(sel.value));
        if (gb) {

            // Etichetta scadenza "parlante": "+12h · ven 15:00" (fix 2026-07-03).
            const WSLAM_STEP_FMT = new Intl.DateTimeFormat('it-IT', {
                weekday: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Rome',
            });
            const wslamStepLabel = (step) => {
                if (!step) return '';
                const ms = Number(step.time_ms) || 0;
                if (!ms) return String(step.label || '');
                const offH = Math.round((ms - Date.now()) / 3600000);
                const rel = offH === 0 ? 'adesso' : (offH > 0 ? `+${offH}h` : `${offH}h`);
                return `${rel} · ${WSLAM_STEP_FMT.format(new Date(ms))}`;
            };
            // Slider e select allineati allo STATO REALE del layer (prima il
            // pannello forzava value=0 lasciando l'indice vero altrove).
            const syncWslamSteps = () => {
                const st = document.getElementById('wslam-steps');
                if (!st) return;
                const steps = getWslamSteps() || [];
                st.max = String(Math.max(0, steps.length - 1));
                const idx = Math.min(getWslamStepIndex(), Math.max(0, steps.length - 1));
                st.value = String(idx);
                st.parentElement.hidden = !steps.length;
                const lab = document.getElementById('wslam-step-label');
                if (lab) lab.textContent = wslamStepLabel(steps[idx]);
            };
            // BUG 2026-07-03: le option erano id inesistenti nel catalogo
            // (temp/precipitation_mm/… vs lam_temp/sst/…) → setWslamProduct
            // era un no-op silenzioso. Le option ora arrivano DAL catalogo.
            const refreshWslamProducts = async () => {
                const wselEl = document.getElementById('wslam-product');
                if (!wselEl) return;
                try {
                    const products = (await getWslamProducts()).filter(p => p.steps > 0);
                    if (!products.length) return;
                    wselEl.replaceChildren(...products.map(p => {
                        const o = document.createElement('option');
                        o.value = p.id;
                        o.textContent = p.label || p.short_label || p.id;
                        return o;
                    }));
                    wselEl.value = getWslamState().product;
                } catch (e) { /* catalogo non disponibile: select com'era */ }
            };
            gb.appendChild(toggleRow('chkWslam', '🔮 Campi modello WSLam', false, async v => {
                const ok = await setWslamEnabled(v);
                if (v && ok) {
                    await refreshWslamProducts();
                    syncWslamSteps();
                } else if (!v) {
                    const st = document.getElementById('wslam-steps');
                    if (st) st.parentElement.hidden = true;
                }
            }));
            const wsel = selRow('wslam-product', [['temp_combined', '🌡️🌊 Temp mare + territorio']], async v2p => {
                await setWslamProduct(v2p);
                syncWslamSteps();
            });
            gb.appendChild(wsel);
            const stepRow = el('<div class="wsv2-range" hidden><span>Ora prevista</span><input type="range" id="wslam-steps" min="0" max="0" value="0" style="flex:1;width:auto"><span id="wslam-step-label"></span></div>');
            // Scrub: 'input' aggiorna SUBITO l'etichetta; il render del campo è
            // debounced (ogni tacca faceva fetch+render completo → drag da 17s).
            let wslamStepTimer = 0;
            const stepInput = stepRow.querySelector('input');
            const commitWslamStep = (i) => {
                if (wslamStepTimer) { clearTimeout(wslamStepTimer); wslamStepTimer = 0; }
                setWslamStep(i);
            };
            stepInput.addEventListener('input', () => {
                const i = Number(stepInput.value) || 0;
                const steps = getWslamSteps() || [];
                const lab = document.getElementById('wslam-step-label');
                if (lab) lab.textContent = wslamStepLabel(steps[i]);
                if (wslamStepTimer) clearTimeout(wslamStepTimer);
                wslamStepTimer = window.setTimeout(() => { wslamStepTimer = 0; setWslamStep(i); }, 180);
            });
            stepInput.addEventListener('change', () => commitWslamStep(Number(stepInput.value) || 0));
            gb.appendChild(stepRow);
            const opRow = el('<div class="wsv2-range"><span>Opacità campo</span><input type="range" min="20" max="100" value="82" style="flex:1;width:auto"></div>');
            opRow.querySelector('input').addEventListener('input', (e) => setWslamOpacity(Number(e.target.value) / 100));
            gb.appendChild(opRow);
        }
    }

    // --- Rischi & allerte / acque (batch B port v1) ----------------------------
    {
        const riskPlacement = {
            alerts: ['risks', '⚠️ Allerte meteo-idro'],
            wildfireAlerts: ['risks', '🔥⚠️ Allerte incendi DRPC'],
            // (2026-07-03: heatWave rimosso come in v1)
            etna: ['risks', '🌋 Stato Etna'],
            waterResources: ['sea', '💧 Risorse idriche'],
            rivers: ['sea', '🏞️ Fiumi (portata)'],
            bathing: ['sea', '🏖️ Balneazione'],
        };
        for (const [key, [grp, label]] of Object.entries(riskPlacement)) {
            const gb = groupEls[grp];
            if (!gb) continue;
            gb.appendChild(toggleRow('risk-' + key, label, false, v => setRiskEnabled(key, v)));
            if (key === 'alerts') gb.appendChild(selRow('risk-alerts-day', [['today', 'Allerta di oggi'], ['tomorrow', 'Allerta di domani']], setAlertsDay));
        }
    }

    // --- Marker mare & extra (batch C port v1) ---------------------------------
    {
        const mePlacement = {
            boe: ['sea', '🌊 Boe'],
            ndbcShips: ['sea', '🛳️ Navi NDBC'],
            ascat: ['sea', '🛰️🌬️ Vento mare satellite'],
            s1wind: ['sea', '🛰️📡 Vento mare HD (radar)'],
            // webcam: spostate nel gruppo "Visualizzazione" (v1 2026-07-03)
            mobile: ['extra', '🚗 MeteoTracker'],
            // (2026-07-03: aviation e icon2i rimossi come in v1)
        };
        for (const [key, [grp, label]] of Object.entries(mePlacement)) {
            const gb = groupEls[grp];
            if (gb) gb.appendChild(toggleRow('me-' + key, label, false, v => setMarineExtraEnabled(key, v)));
        }
        groupEls.extra?.appendChild(toggleRow('chkSpaghetti', '🍝 Spaghi modelli', false, v => setSpaghettiEnabled(v)));
        // Nuovi layer DRPC (v1 2026-07-02): idrometri + neve al suolo
        groupEls.sea?.appendChild(toggleRow('chkNeve', '❄️ Neve al suolo (DRPC)', false, v => setDrpcExtraEnabled('neve', v)));
        groupEls.sea?.appendChild(toggleRow('chkWaveAnim', '🌊✨ Onde animate', false, v => setWaveAnimEnabled(v)));
    }

    // --- Province & filtri (semantica v1: flyTo + filtro poligonale) ----------
    const PROVINCES = { PA: [38.1157, 13.3615], TP: [37.8338, 12.5715], AG: [37.3123, 13.5747], CL: [37.4901, 14.0629], EN: [37.5674, 14.2798], CT: [37.5027, 15.0873], ME: [38.1938, 15.5540], RG: [36.9250, 14.7306], SR: [37.0755, 15.2866], RC: [38.1105, 15.6613] };
    const gFil = group('📍 Province & filtri', 'filters', false);
    const fb = gFil.querySelector('.wsv2-group__body');
    const prov = el(`<div class="wsv2-prov">${Object.keys(PROVINCES).map(s2 => `<button data-p="${s2}">${s2}</button>`).join('')}<button data-p="">Tutte</button></div>`);
    prov.querySelectorAll('button').forEach(btn => btn.addEventListener('click', () => {
        prov.querySelectorAll('button').forEach(x => x.classList.remove('active'));
        const sig = btn.dataset.p || null;
        if (sig) {
            btn.classList.add('active');
            const [la, lo] = PROVINCES[sig];
            map.flyTo({ center: [lo, la], zoom: 10 });
        } else {
            // "Tutte": si toglie il filtro → si torna alla vista Sicilia intera
            // (altrimenti la mappa resta zoomata sull'ultima provincia scelta).
            map.fitBounds(SICILY_BOUNDS, { padding: 24 });
        }
        setFilters({ province: sig });
        // Oscura tutto fuori provincia (funzione v1); "Tutte" → sig null → pulisce.
        setProvinceMask(map, sig);
    }));
    fb.appendChild(prov);
    // Slider doppio (min/max) come la v1 (.ws-dual-range): due range sovrapposti,
    // etichetta con i valori correnti; ai due estremi = nessun filtro (null).
    const mkRange = (label, key1, key2, min, max, step) => {
        let cfg = { label, min, max, step };
        const r = el(`<div class="wsv2-dual">
            <div class="wsv2-dual__head"><span>${label}</span><b class="wsv2-dual__val"></b></div>
            <div class="wsv2-dual__slot">
                <input type="range" class="wsv2-dual__lo" min="${min}" max="${max}" step="${step}" value="${min}">
                <input type="range" class="wsv2-dual__hi" min="${min}" max="${max}" step="${step}" value="${max}">
            </div>
        </div>`);
        const lo = r.querySelector('.wsv2-dual__lo'), hi = r.querySelector('.wsv2-dual__hi');
        const title = r.querySelector('.wsv2-dual__head span'), val = r.querySelector('.wsv2-dual__val');
        const fmt = (v) => {
            const n = Number(v);
            if (!Number.isFinite(n)) return String(v);
            return Math.abs(n) >= 100 || Number.isInteger(n) ? String(Math.round(n)) : n.toFixed(1);
        };
        const show = () => { val.textContent = `${fmt(lo.value)} – ${fmt(hi.value)}`; };
        const apply = () => setFilters({
            [key1]: Number(lo.value) <= cfg.min ? null : Number(lo.value),
            [key2]: Number(hi.value) >= cfg.max ? null : Number(hi.value),
        });
        r.configure = (next, reset = true) => {
            cfg = { ...cfg, ...next };
            title.textContent = cfg.label;
            for (const input of [lo, hi]) {
                input.min = String(cfg.min);
                input.max = String(cfg.max);
                input.step = String(cfg.step);
            }
            if (reset) {
                lo.value = String(cfg.min);
                hi.value = String(cfg.max);
                apply();
            } else {
                lo.value = String(Math.max(cfg.min, Math.min(cfg.max, Number(lo.value))));
                hi.value = String(Math.max(cfg.min, Math.min(cfg.max, Number(hi.value))));
                if (Number(lo.value) > Number(hi.value)) lo.value = hi.value;
            }
            show();
        };
        lo.addEventListener('input', () => { if (Number(lo.value) > Number(hi.value)) lo.value = hi.value; show(); });
        hi.addEventListener('input', () => { if (Number(hi.value) < Number(lo.value)) hi.value = lo.value; show(); });
        lo.addEventListener('change', apply); hi.addEventListener('change', apply);
        show();
        return r;
    };
    fb.appendChild(mkRange('Quota (m)', 'altMin', 'altMax', 0, 3400, 50));
    const valueRange = mkRange('Valore', 'valMin', 'valMax', -50, 100, 1);
    valueRange.configure(valueFilterRange(sel.value), true);
    sel.addEventListener('change', () => valueRange.configure(valueFilterRange(sel.value), true));
    fb.appendChild(valueRange);
    // Province in CIMA al menu laterale (richiesta Giuseppe): prepend, non append.
    body.prepend(gFil);
    // Conteggio stazioni nel menu principale: libera spazio nella card "Dato stazioni".
    body.prepend(activeBox);

    // --- Viste salvate + reset -----------------------------------------------
    buildToolsGroup(map, group, toggleRow, body);


    // Espandi/comprimi TUTTE le sezioni con un solo tasto (nell'header del pannello,
    // accanto alla ✕). Il tasto è "smart": se anche una sola sezione è chiusa apre
    // tutto, altrimenti chiude tutto. Persiste lo stato di ogni gruppo (wsv2-groups)
    // così la scelta sopravvive al reload, coerente col toggle singolo.
    const collapseBtn = el('<button type="button" class="wsv2-iconbtn wsv2-collapse-all" style="width:30px;height:30px;font-size:15px;margin-left:auto"></button>');
    const allGroups = () => [...body.querySelectorAll('.wsv2-group')];
    const syncCollapseBtn = () => {
        const groups = allGroups();
        const allOpen = groups.length > 0 && groups.every(g => g.open);
        collapseBtn.textContent = allOpen ? '⊟' : '⊞';
        collapseBtn.title = allOpen ? 'Comprimi tutte le sezioni' : 'Espandi tutte le sezioni';
        collapseBtn.setAttribute('aria-label', collapseBtn.title);
    };
    collapseBtn.addEventListener('click', () => {
        const groups = allGroups();
        const target = !groups.every(g => g.open); // qualcuna chiusa → apri tutto; sennò chiudi
        let saved = {};
        try { saved = JSON.parse(localStorage.getItem('wsv2-groups') || '{}'); } catch (e) {}
        for (const g of groups) { g.open = target; if (g.dataset.group) saved[g.dataset.group] = target; }
        try { localStorage.setItem('wsv2-groups', JSON.stringify(saved)); } catch (e) {}
        syncCollapseBtn();
    });
    // Tiene l'icona coerente quando si apre/chiude una singola sezione a mano.
    body.addEventListener('click', (e) => { if (e.target.closest('.wsv2-group__head')) syncCollapseBtn(); });
    const layersHeader = document.querySelector('#layersPanel header');
    const closeBtn = document.getElementById('btnLayersClose');
    if (layersHeader) { closeBtn ? layersHeader.insertBefore(collapseBtn, closeBtn) : layersHeader.appendChild(collapseBtn); }
    if (closeBtn) closeBtn.style.marginLeft = '6px';
    syncCollapseBtn();
    mountActiveLayers(body);

    // Apri/chiudi pannello (+scrim su mobile)
    const panel = document.getElementById('layersPanel');
    const layersButton = document.getElementById('btnLayers');
    if (urlState?.raw?.get('controls') === 'layers') {
        document.documentElement.classList.add('wsv2-layer-controls');
        layersButton.textContent = 'Livelli mappa ▾';
        layersButton.setAttribute('aria-label', 'Livelli mappa');
        body.prepend(gNow);
        gNow.open = true;
    }
    layersButton?.setAttribute('aria-controls', 'layersPanel');
    layersButton?.setAttribute('aria-expanded', 'false');
    const scrim = el('<div class="wsv2-scrim" hidden></div>');
    document.body.appendChild(scrim);
    const setOpen = (open) => {
        panel.classList.toggle('open', open);
        layersButton?.setAttribute('aria-expanded', String(open));
        scrim.hidden = !open || !window.matchMedia('(max-width: 820px)').matches;
    };
    document.getElementById('btnLayers')?.addEventListener('click', () => setOpen(!panel.classList.contains('open')));
    document.getElementById('btnLayersClose')?.addEventListener('click', () => setOpen(false));
    scrim.addEventListener('click', () => setOpen(false));
    panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') { setOpen(false); layersButton?.focus(); }
    });

    // Tema
    document.getElementById('btnTheme')?.addEventListener('click', () => {
        const dark = !document.documentElement.classList.contains('ws-theme-dark');
        document.documentElement.classList.toggle('ws-theme-dark', dark);
        try { localStorage.setItem('ws-theme', dark ? 'dark' : 'light'); } catch (e) {}
        document.dispatchEvent(new CustomEvent('wsv2:theme', { detail: { dark } }));
    });
}

// --- Guida ai parametri (port v1 #param-info-popover) ------------------------
const PARAM_GUIDE = [
    ['🌧️ Intensità (mm/h)', "Ritmo di pioggia istantaneo: quanti millimetri cadrebbero in un'ora a questa intensità. Diverso dal totale giornaliero."],
    ['💧 Dew Point (Punto di rugiada)', "Temperatura a cui l'aria, raffreddandosi, si satura e l'umidità inizia a condensare. Più è alto, più l'aria è umida e afosa."],
    ['🌡️ Temp. Percepita', "Quanto caldo o freddo sente il corpo: combina la temperatura reale con l'umidità (caldo) o con il vento (freddo)."],
    ['🥵 Humidex', "Indice di disagio da caldo-umido (temperatura + punto di rugiada). Oltre 40 forte disagio, oltre 45 condizioni pericolose."],
    ['💦 Bulbo Umido (Wet bulb)', "Temperatura più bassa ottenibile per sola evaporazione: è il limite di raffreddamento del corpo col sudore. Valori sopra ~32 °C sono pericolosi anche all'ombra."],
    ['🌫️ Spread T-Dp', "Differenza tra temperatura e punto di rugiada. Vicino a 0 l'aria è satura (nebbia o rugiada probabili); valori alti indicano aria secca."],
    ['🧊 Wind Chill', "Temperatura percepita al freddo: il vento accelera la dispersione del calore corporeo facendo sentire più freddo del valore reale."],
];

function initParamGuide(btn) {
    if (!btn) return;
    let pop = null;
    const build = () => {
        const p = document.createElement('div');
        p.className = 'wsv2-param-guide';
        p.setAttribute('role', 'dialog');
        p.setAttribute('aria-label', 'Guida ai parametri meteo');
        p.hidden = true;
        p.innerHTML = `
            <header>Cosa indicano i parametri
                <button type="button" class="wsv2-param-guide__close" aria-label="Chiudi guida parametri">×</button>
            </header>
            <p>Spiegazione rapida degli indici meno comuni, così sai cosa stai guardando sulla mappa.</p>
            <dl>${PARAM_GUIDE.map(([t, d]) => `<dt>${t}</dt><dd>${d}</dd>`).join('')}</dl>`;
        document.body.appendChild(p);
        p.querySelector('.wsv2-param-guide__close').addEventListener('click', () => { p.hidden = true; });
        // chiudi cliccando fuori
        document.addEventListener('click', (e) => {
            if (!p.hidden && !p.contains(e.target) && e.target !== btn) p.hidden = true;
        });
        return p;
    };
    btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!pop) pop = build();
        pop.hidden = !pop.hidden;
    });
}
